import Box from './Box'

const TrippleBox = ({ lines, x, y, width, height, className, ...props }) => {
	const margin = 5
	const box_height = (height - margin * 2) / 3;
	const box_width = width -  margin * 2

	return (
		<>
			<rect {...props} className={className + " box"} rx="10" x={x} y={y} width={width} height={height} />
			<Box
				lines={lines[0]}
				x={x + margin}
				y={y + margin}
				width={box_width}
				height={box_height + 5}
				className="inner"
			/>
			<Box
				lines={lines[2]}
				x={x + margin}
				y={y + box_height * 2 - 5}
				width={box_width}
				height={box_height + margin + 5}
				paddingTop={true}
				className="inner"
			/>
			<Box
				lines={lines[1]}
				x={x + margin}
				y={y + box_height * 1}
				width={box_width}
				height={box_height}
				className="no-borders"
			/>
		</>
	)
}


export default TrippleBox
